import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import RadioGroup from '@material-ui/core/RadioGroup';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import PreviewIcon from '@material-ui/icons/ImageSearch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Create';
import LinkIcon from '@material-ui/icons/Link';
import { getMarketName, getLanguage } from '../../features/app/selectors';
import { ppsiInProgressRoute, ppsiPublishedRoute } from '../../routes';
import { States } from '../../features/PpiContainer/constants';
import PpsiTable from './PpsiTable';
import { toJS } from 'utils/immutableUtils';
import { stitchPpis } from 'utils/ui2pStitchPPI';
import stichPpsi from 'utils/ui2pStitchPPSI';
import ui2pStitchPPSI from 'utils/ui2pStitchPPSI';
import { MARKET_GLOBAL_LANG } from 'features/app/constants';
import {
  fetchPpsi,
  setPPSIId,
  showPopUp
} from 'features/PpsiContainer/actions';
import {
  getIsFetching,
  getPpsiId,
  getPpsisWithFilter,
  getShow
} from 'features/PpsiContainer/selectors';
import {
  getIsFetching as fetchPpis,
  getPpisWithStatus
} from 'features/PpiContainer/selectors';
import { fetchPpisRelatedToPpsi } from 'features/PpiContainer/actions';

const useStyles = makeStyles({
  radioGroupRoot: {
    display: 'block'
  },
  radioButtonRoot: {
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem'
    }
  },
  ppsiLabelContainer: {
    userSelect: 'none'
  }
});

const PpsiList = ({
  ppsis = [],
  selectedPpsiDataId,
  onChangeSelectedPpsi,
  openPreview,
  language,
  isExcluded,
  localPpsiCopy
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  // const [isFetchingGlobalPpsis, globalPpsisRaw] = useGlobalPpsis();
  const history = useHistory();
  const userMarket = useSelector(getMarketName);
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(isExcluded);
  const ppsiId = useSelector(getPpsiId);
  const ppsisWithFilter = useSelector(
    getPpsisWithFilter({ status: 'PUBLISHED' })
  );
  const isFetching = useSelector(getIsFetching);
  const isFetchingPpis = useSelector(fetchPpis);
  const ppisWithStatus = useSelector(getPpisWithStatus('PUBLISHED'));
  const unpublishedPpsisRaw = useSelector(
    getPpsisWithFilter({ status: 'UNPUBLISHED' })
  );
  const ppis = toJS(ppisWithStatus);
  const allPpsis = [...toJS(ppsisWithFilter), ...toJS(unpublishedPpsisRaw)];
  const [previewClicked, setPreviewClicked] = useState(false);

  // const marketLanguage = useSelector(getLanguage);
  // const languages = localPpsiCopy === 'true' ? marketLanguage : language;
  // const [isFetchingGlobalPpis, globalPpisRaw] = useGlobalPpis();
  // const globalPpis = toJS(globalPpisRaw, []);

  const checkPpsiExist = allPpsis.filter(ppsi => ppsi.id === ppsiId);
  useEffect(() => {
    if (
      ppsiId &&
      !isFetchingPpis &&
      checkPpsiExist.length &&
      previewClicked &&
      !isFetching
    ) {
      dispatch(showPopUp(false));
      setPreviewClicked(false);
      dispatch(setPPSIId(null));
      finalPPSI(ppsiId, openPreview, checkPpsiExist);
    }
  }, [ppsiId, checkPpsiExist, ppis]);

  if (!ppsis) {
    return null;
  }

  function openPublishedPpsi(ppsiId) {
    history.push(ppsiPublishedRoute(ppsiId));
  }

  function handleExcludeChange(event) {
    setSelected(!selected);
    onChangeSelectedPpsi(event, { selected });
  }
  const dataToPass = isExcluded === undefined ? false : isExcluded;
  const exclude = (
    <FormControlLabel
      value={dataToPass}
      control={
        <Radio
          classes={{ root: classes.radioButtonRoot }}
          onClick={event => handleExcludeChange(event)}
          checked={dataToPass}
        />
      }
      label={
        <div className={classes.ppsiLabelContainer}>
          <Typography variant="body2">Exclude</Typography>
        </div>
      }
    />
  );

  function getPublishedData(ppsi) {
    const dish = ppsi.referencedIFoodData;
    return {
      ...ppsi,
      ppsiId: ppsi.id,
      dish
    };
  }

  function finalPPSI(id, openPreview, allPpsis) {
    const data = allPpsis.filter(itm => itm.id === id)[0]
      .publishedPpsiEnrichmentData;
    let ppiDataIds = data.ppiDetails.map(a => a.ppiEnrichmentDataId);
    let usedPpis = [];
    const pervPpiDetails = data.ppiDetails;
    if (ppiDataIds.length) {
      usedPpis =
        ppis &&
        ppis
          .filter(
            ppi =>
              ppi.publishedPPIEnrichmentData &&
              ppiDataIds.includes(ppi.publishedPPIEnrichmentData.id)
          )
          .map(ppi => ppi.publishedPPIEnrichmentData);
    }

    const referencedIngredientEntities = data.referencedIFoodData.referencedIngredientEntities.map(
      a => {
        if (Object.keys(a.amount.metric.info).includes('EN-IF')) {
          a.amount.metric.info[language] = a.amount.metric.info['EN-IF'];
          a.amount.imperial.info[language] = a.amount.imperial.info['EN-IF'];
          a.presentationName[language] = a.presentationName['EN-IF'];
        }
        return a;
      }
    );
    const ppsi = ui2pStitchPPSI(
      getPublishedData(data),
      stitchPpis(usedPpis),
      referencedIngredientEntities,
      language ? language : MARKET_GLOBAL_LANG
    );
    const getExcludedItemCodes =
      pervPpiDetails &&
      pervPpiDetails
        .filter(i => i.ppiNotRequired === true)
        .map(i => i.itemCode);

    const ppiWithoutExcludeData =
      ppsi &&
      ppsi.ppiDetails.filter(i => !getExcludedItemCodes.includes(i.itemCode));
    let dataa = {
      ...ppsi,
      ppiDetails: ppiWithoutExcludeData,
      updateNotificationList: []
    };
    openPreview({ ...dataa, hideBackButton: true }, language);
  }

  function buildEnrichmentRow({
    id,
    publishedEnrichmentDataId,
    market,
    data,
    piaArticleNumber,
    presentationName,
    formulaCode,
    status
  }) {
    let checkSinglePpsiExist = allPpsis.filter(ppsi => ppsi.id === id);
    if (checkSinglePpsiExist.length && ppsiId) {
      data = checkSinglePpsiExist.map(a => a.publishedPpsiEnrichmentData)[0];
    }
    let ppiDataIds = [];
    let pervPpiDetails = [];
    if (data) {
      ppiDataIds = data.ppiDetails.map(a => a.ppiEnrichmentDataId);
      pervPpiDetails = data.ppiDetails;
    }
    let usedPpis = [];
    if (ppiDataIds.length && data) {
      usedPpis =
        ppis &&
        ppis
          .filter(
            ppi =>
              ppi.publishedPPIEnrichmentData &&
              ppiDataIds.includes(ppi.publishedPPIEnrichmentData.id)
          )
          .map(ppi => ppi.publishedPPIEnrichmentData);
    }

    let ppsi = {};
    let referencedIngredientEntities = [];
    if (data) {
      referencedIngredientEntities = data.referencedIFoodData.referencedIngredientEntities.map(
        a => {
          if (Object.keys(a.amount.metric.info).includes('EN-IF')) {
            a.amount.metric.info[language] = a.amount.metric.info['EN-IF'];
            a.amount.imperial.info[language] = a.amount.imperial.info['EN-IF'];
            a.presentationName[language] = a.presentationName['EN-IF'];
          }
          return a;
        }
      );
    }
    if (data && data.referencedIFoodData) {
      ppsi = stichPpsi(
        data.referencedIFoodData && getPublishedData(data),
        data.referencedIFoodData && stitchPpis(usedPpis),
        data.referencedIFoodData && referencedIngredientEntities,
        language
      );
    }

    const getExcludedItemCodes =
      pervPpiDetails &&
      pervPpiDetails
        .filter(i => i.ppiNotRequired === true)
        .map(i => i.itemCode);

    let ppiWithoutExcludeData = [];
    if (ppsi.ppiDetails) {
      ppiWithoutExcludeData =
        ppsi &&
        ppsi.ppiDetails.filter(i => !getExcludedItemCodes.includes(i.itemCode));
    }

    data = {
      ...ppsi,
      ppiDetails: ppiWithoutExcludeData,
      updateNotificationList: []
    };

    const piaNumber = piaArticleNumber;
    const ifoodId = (
      <FormControlLabel
        value={publishedEnrichmentDataId}
        control={
          <Radio
            classes={{ root: classes.radioButtonRoot }}
            onClick={event => onChangeSelectedPpsi(event, { id })}
            checked={publishedEnrichmentDataId === selectedPpsiDataId}
          />
        }
        label={
          <div className={classes.ppsiLabelContainer}>
            <Typography variant="body2">{formulaCode}</Typography>
          </div>
        }
      />
    );
    const name = presentationName;

    const actions = (
      <>
        <Tooltip
          title={formatMessage({
            id: 'ppsi.previewInstructionTooltip'
          })}
        >
          <IconButton
            onClick={() => {
              // dispatch(setPPSIId(id));
              // dispatch(fetchPpsi(id));
              // dispatch(fetchPpisRelatedToPpsi(id));
              if (!data.ppiDetails.length) {
                setPreviewClicked(true);
                dispatch(showPopUp(true));
                dispatch(setPPSIId(id));
                dispatch(fetchPpsi(id));
                dispatch(fetchPpisRelatedToPpsi(id));
              } else {
                openPreview({ ...data, hideBackButton: true }, language);
              }
            }}
            color="secondary"
            size="medium"
          >
            <PreviewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        {/* {status === States.DRAFT && market === userMarket && (
          <Tooltip
            title={formatMessage({
              id: 'ppsi.editPpsiActionTooltip'
            })}
          >
            <IconButton
              onClick={() => editPpsi(id)}
              color="secondary"
              size="medium"
            >2
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )} */}
        {/* {(status === States.PUBLISHED || status === States.UNPUBLISHED) &&
          market === userMarket &&
           (
            <Tooltip
              title={formatMessage({
                id: 'ppsi.openPpsiActionTooltip'
              })}
            >
              <IconButton
                onClick={() => openPublishedPpsi(id)}
                color="secondary"
                size="medium"
              >
                <LinkIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )} */}
      </>
    );

    return {
      id: publishedEnrichmentDataId,
      ifoodId,
      name,
      status,
      piaNumber,
      actions
    };
  }

  let rows = [];
  rows = rows.concat(
    ppsis.map(
      ({
        id,
        formulaCode,
        market,
        publishedPpsiEnrichmentData: data,
        piaArticleNumber,
        info,
        status,
        publishedEnrichmentDataId
      }) => {
        const presentationName = info[language].presentationName;
        const row = buildEnrichmentRow({
          id,
          formulaCode,
          market,
          data,
          piaArticleNumber,
          presentationName,
          status,
          publishedEnrichmentDataId
        });
        return row;
      }
    )
  );
  // rows = rows.concat(

  // )

  if (localPpsiCopy !== 'true') {
    rows = rows.concat(
      ppsis
        .filter(ppsi => ppsi.inProgressPpsiEnrichmentData)
        .map(
          ({ id, formulaCode, market, inProgressPpsiEnrichmentData: data }) =>
            buildEnrichmentRow({ id, formulaCode, market, data })
        )
    );
  }

  return (
    <>
      <RadioGroup name="ppsis" classes={{ root: classes.radioGroupRoot }}>
        {rows.length === 0 ? (
          <p
            style={{ color: '#9c9a98', fontSize: '16px', marginBottom: '30px' }}
          >
            No Dish found!
          </p>
        ) : (
          <PpsiTable
            rows={rows}
            exclude={exclude}
            key={Math.random()}
            dataLoaded={previewClicked}
          />
        )}
      </RadioGroup>
    </>
  );
};

PpsiList.propTypes = {
  language: PropTypes.string.isRequired,
  onChangeSelectedPpsi: PropTypes.func,
  openPreview: PropTypes.func,
  ppsis: PropTypes.array,
  selectedPpsiDataId: PropTypes.string
};

export default PpsiList;
